import { apiGet } from './client';

// Generic single-table record search. The backend returns row objects keyed by
// column name (so callers index by the table's actual column names). Used by the
// FORM infrastructure's top autocomplete and the record-picker modal.
export function searchRecords(
  table: string,
  q: string,
  limit = 50,
): Promise<Record<string, unknown>[]> {
  return apiGet<Record<string, unknown>[]>(
    `/api/search/${encodeURIComponent(table)}?q=${encodeURIComponent(q)}&limit=${limit}`,
  );
}
